export default "__VITE_ASSET__w$vdvxNH__"